export const FETCH_WHATSAPP_CONFIRMATION_CHARGES_REQUEST = "FETCH_WHATSAPP_CONFIRMATION_CHARGES_REQUEST";
export const FETCH_WHATSAPP_CONFIRMATION_CHARGES_SUCCESS = "FETCH_WHATSAPP_CONFIRMATION_CHARGES_SUCCESS";
export const FETCH_WHATSAPP_CONFIRMATION_CHARGES_FAILURE = "FETCH_WHATSAPP_CONFIRMATION_CHARGES_FAILURE";
export const FETCH_WHATSAPP_CONFIRMATION_CHARGES_RESET = "FETCH_WHATSAPP_CONFIRMATION_CHARGES_RESET";
export const fetchWhatsappConfirmationChargesRequest = (payload) => ({
    type: FETCH_WHATSAPP_CONFIRMATION_CHARGES_REQUEST,
    payload,
});
export const fetchWhatsappConfirmationChargesSuccess = (payload) => ({
    type: FETCH_WHATSAPP_CONFIRMATION_CHARGES_SUCCESS,
    payload,
});
export const fetchWhatsappConfirmationChargesFailure = (payload) => ({
    type: FETCH_WHATSAPP_CONFIRMATION_CHARGES_FAILURE,
    payload,
});
export const fetchWhatsappConfirmationChargesReset = () => ({
    type: FETCH_WHATSAPP_CONFIRMATION_CHARGES_RESET,
});
